// extracted by mini-css-extract-plugin
module.exports = {"reassurance":"_28sa2hb3hoI5wBwVktxDFw","reasCol":"_1tAK3p-cS9YHhmj1RrQ5nc","text":"_1sW5C41GU2gX52cvZr0rTG"};